import { useNumberLocaleConfig } from '../hooks/useNumberLocaleConfig'
import AppInputMasked from './AppInputMasked'

const AppInputMaskedLocalized = ({ ...props }) => {
  const { decimal, group } = useNumberLocaleConfig()

  return (
    <AppInputMasked
      mask={Number}
      unmask={false}
      scale={props.scale ?? 2}
      thousandsSeparator={group}
      radix={decimal}
      onAccept={value => {
        if (value === undefined) {
          props.onChange('')
          return
        }
        props.onChange(value)
      }}
      mapToRadix={[',', '.']}
      autofix
      max={props.max ?? 9_999_999.99}
      {...props}
    />
  )
}

export default AppInputMaskedLocalized
